export default {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.services': 'الخدمات',
  'nav.register': 'التسجيل',
  'nav.blog': 'المدونة',
  'nav.tryFree': 'جرب مجاناً',
  
  // Hero Section
  'hero.title1': 'تحكم كامل في',
  'hero.title2': 'إدارة صالتك الرياضية',
  'hero.description': 'نظام إدارة متكامل يوفر لك لوحة تحكم احترافية لتتبع الإيرادات والاشتراكات والحضور والفواتير في مكان واحد. مع تقارير تحليلية متقدمة لاتخاذ قرارات أفضل.',
  'hero.tryFree': 'جرب مجاناً لمدة 14 يوم',
  'hero.requestDemo': 'طلب عرض توضيحي',
  'hero.revenue': 'الإيرادات',
  'hero.fromLastMonth': 'من الشهر الماضي',
  'hero.totalMemberships': 'إجمالي الاشتراكات',
  'hero.active': 'نشط',
  'hero.inactive': 'غير نشط',
  'hero.newMemberships': 'اشتراكات جديدة',
  'hero.thisMonth': 'هذا الشهر',
  
  // Why Choose Section
  'whyChoose.title': 'لماذا تختارنا',
  'whyChoose.description': 'نظام متكامل يلبي جميع احتياجات صالتك الرياضية بواجهة سهلة الاستخدام ومميزات متقدمة',
  'whyChoose.timeSaving': 'توفير الوقت',
  'whyChoose.timeSavingDesc': 'أتمتة العمليات اليومية وتقليل الوقت المستغرق في المهام الإدارية بنسبة تصل إلى 70%',
  'whyChoose.analytics': 'تحليلات متقدمة',
  'whyChoose.analyticsDesc': 'رؤية شاملة لأداء صالتك الرياضية مع تقارير تفصيلية ولوحات تحكم قابلة للتخصيص',
  'whyChoose.experience': 'تجربة عملاء مميزة',
  'whyChoose.experienceDesc': 'تطبيق للأعضاء يتيح حجز الحصص وتتبع التقدم والتواصل المباشر مع المدربين',
  
  // Services Section
  'services.title': 'الخدمات',
  'services.description': 'مجموعة شاملة من الحلول المصممة خصيصاً لتلبية احتياجات الصالات الرياضية',
  'services.membership.title': 'إدارة الاشتراكات',
  'services.membership.description': 'إدارة كاملة لبيانات الأعضاء والاشتراكات والتجديد التلقائي وإشعارات انتهاء العضوية',
  'services.membership.feature1': 'ملفات تعريف مخصصة للأعضاء',
  'services.membership.feature2': 'إدارة الاشتراكات',
  'services.membership.feature3': 'بطاقات عضوية إلكترونية',
  'services.scheduling.title': 'جدولة الحصص',
  'services.scheduling.description': 'جدولة سهلة وفعالة للحصص مع حجز المواعيد وإدارة الموارد',
  'services.scheduling.feature1': 'جدولة متقدمة للحصص والمدربين',
  'services.scheduling.feature2': 'نظام حجز عبر الإنترنت',
  'services.scheduling.feature3': 'تذكيرات تلقائية بالمواعيد',
  'services.payment.title': 'إدارة المدفوعات',
  'services.payment.description': 'نظام دفع متكامل يدعم طرق دفع متنوعة مع تقارير مالية تفصيلية',
  'services.payment.feature1': 'دعم طرق دفع متعددة',
  'services.payment.feature2': 'فواتير وإيصالات إلكترونية',
  'services.payment.feature3': 'تقارير مالية وضريبية',
  'services.analytics.title': 'التحليلات والتقارير',
  'services.analytics.description': 'لوحات تحكم تحليلية متقدمة وتقارير تفصيلية لمساعدتك في اتخاذ قرارات مستنيرة',
  'services.analytics.feature1': 'تحليلات الإيرادات والمصروفات',
  'services.analytics.feature2': 'تقارير الحضور والنشاط',
  'services.analytics.feature3': 'مؤشرات الأداء الرئيسية',
  'services.memberApp.title': 'تطبيق الأعضاء',
  'services.memberApp.description': 'تطبيق مخصص للأعضاء لحجز الحصص وتتبع التقدم والتواصل المباشر مع المدربين',
  'services.memberApp.feature1': 'حجز الحصص والمواعيد',
  'services.memberApp.feature2': 'تتبع التقدم والأهداف',
  'services.memberApp.feature3': 'التواصل المباشر مع المدربين',
  'services.inventory.title': 'إدارة المخزون',
  'services.inventory.description': 'إدارة سهلة للمخزون والمنتجات مع تقارير تفصيلية للمبيعات والمخزون',
  'services.inventory.feature1': 'إدارة كتالوج المنتجات',
  'services.inventory.feature2': 'نقطة بيع متكاملة',
  'services.inventory.feature3': 'تقارير المبيعات والأرباح',
  
  // Statistics Section
  'stats.revenue': 'الإيرادات',
  'stats.netProfit': 'صافي الربح',
  'stats.members': 'الأعضاء',
  'stats.fromPreviousMonth': 'من الشهر السابق',
  'stats.income': 'الدخل',
  'stats.expenses': 'المصروفات',
  'stats.organicSources': 'المصادر العضوية',
  'stats.socialMedia': 'وسائل التواصل الاجتماعي',
  'stats.friends': 'الأصدقاء',
  'stats.directVisit': 'زيارة مباشرة',
  'stats.calls': 'المكالمات',
  'stats.billingStatus': 'حالة الفواتير',
  'stats.newMembership': 'عضوية جديدة',
  'stats.newSubscription': 'اشتراك جديد',
  'stats.newSession': 'جلسة جديدة',
  'stats.renewal': 'تجديد',
  'stats.extension': 'تمديد',
  
  // Registration Section
  'register.title1': 'ابدأ رحلتك مع',
  'register.title2': '5vix',
  'register.title3': 'اليوم',
  'register.description': 'سجل الآن واحصل على فترة تجريبية مجانية لمدة 14 يوماً. لا حاجة لبطاقة ائتمان، بدون التزامات.',
  'register.quickSetup': 'إعداد سريع',
  'register.quickSetupDesc': 'ابدأ استخدام النظام في دقائق معدودة، مع دعم فني مستمر',
  'register.dataSafe': 'بياناتك آمنة',
  'register.dataSafeDesc': 'نظام آمن بالكامل مع تشفير البيانات ونسخ احتياطية منتظمة',
  'register.support': 'دعم فني على مدار الساعة',
  'register.supportDesc': 'فريق دعم متخصص جاهز لمساعدتك في أي وقت',
  'register.formTitle': 'إنشاء حساب جديد',
  'register.firstName': 'الاسم الأول',
  'register.lastName': 'اسم العائلة',
  'register.gymName': 'اسم الصالة الرياضية',
  'register.email': 'البريد الإلكتروني',
  'register.phone': 'رقم الهاتف',
  'register.package': 'الباقة',
  'register.selectPackage': 'اختر الباقة',
  'register.basic': 'أساسية',
  'register.professional': 'احترافية',
  'register.integrated': 'متكاملة',
  'register.createAccount': 'إنشاء حساب',
  
  // Testimonials Section
  'testimonials.title': 'ماذا يقول عملاؤنا',
  'testimonials.description': 'آراء أصحاب الصالات الرياضية الذين يستخدمون نظام 5vix',
  'testimonials.customer1.name': 'فهد جمال',
  'testimonials.customer1.role': 'مالك صالة فيت بانش',
  'testimonials.customer1.text': 'لنا في المجال حوالي 6 سنوات وكنا نعاني من مشاكل في الرواتب والحضور. لكن بعد نظام فايف فيكس، كل شيء أصبح سهلاً من الجوال، والدعم دائماً سريع في حل أي مشكلة أو تعديل',
  'testimonials.customer2.name': 'أحمد خيرات',
  'testimonials.customer2.role': 'مالك سايبورج كاليسثينكس',
  'testimonials.customer2.text': 'الإتقان والتطوير المستمر والخدمة الممتازة تلخص تجربتي مع التطبيق. أنصح أي شخص يبحث عن التطوير أن يبدأ رحلته مع التطبيق',
  'testimonials.customer3.name': 'عبدالله الراشد',
  'testimonials.customer3.role': 'مالك سلسلة باور جيم',
  'testimonials.customer3.text': 'دعم فني ممتاز، وتحديثات مستمرة تضيف ميزات جديدة باستمرار. التقارير والتحليلات ساعدتني أفهم أعمالي بشكل أفضل وأتخذ قرارات أذكى.',
  
  // Blog Section
  'blog.title': 'أحدث المقالات',
  'blog.description': 'نصائح وإرشادات لتطوير صالتك الرياضية وتحسين تجربة أعضائك',
  'blog.article1.title': '10 استراتيجيات لزيادة معدل الاحتفاظ بالأعضاء',
  'blog.article1.description': 'تعرف على أفضل الاستراتيجيات المثبتة لزيادة معدل الاحتفاظ بأعضائك وتقليل معدل التسرب.',
  'blog.article1.author': 'أحمد الشمري',
  'blog.article2.title': 'كيف تختار أفضل المدربين لصالتك الرياضية',
  'blog.article2.description': 'دليل شامل لاختيار وتوظيف وتطوير فريق من المدربين المحترفين لتقديم تجربة ممتازة لأعضائك.',
  'blog.article2.author': 'نورة الخالدي',
  'blog.article3.title': 'تحليل البيانات: مفتاح نجاح صالتك الرياضية',
  'blog.article3.description': 'كيفية استخدام تحليل البيانات لاتخاذ قرارات أفضل وتحسين أداء صالتك الرياضية وزيادة الإيرادات.',
  'blog.article3.author': 'خالد السعيد',
  'blog.readMore': 'اقرأ المزيد',
  'blog.viewAll': 'عرض جميع المقالات',
  
  // CTA Section
  'cta.title': 'هل أنت مستعد لتحسين إدارة صالتك الرياضية؟',
  'cta.description': 'انضم إلى آلاف الصالات الرياضية التي تستخدم 5vix لتحسين الكفاءة التشغيلية وتقديم تجربة ممتازة للأعضاء.',
  'cta.button': 'ابدأ الآن مجاناً',
  
  // Footer
  'footer.description': 'نظام متكامل لإدارة الصالات الرياضية يساعدك على تنظيم الاشتراكات وجدولة الحصص وتتبع الحضور وتحليل الأداء بسهولة.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.support': 'الدعم',
  'footer.helpCenter': 'مركز المساعدة',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.contactUs': 'اتصل بنا',
  'footer.terms': 'الشروط والأحكام',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.newsletter': 'النشرة الإخبارية',
  'footer.newsletterDesc': 'اشترك في نشرتنا الإخبارية للحصول على آخر الأخبار والتحديثات',
  'footer.subscribe': 'اشترك',
  'footer.cookies': 'ملفات تعريف الارتباط',
  'footer.copyright': '© 2025 5vix. جميع الحقوق محفوظة.',
  
  // Help Center
  helpCenter: {
    title: 'مركز المساعدة',
    subtitle: 'ابحث عن إجابات لأسئلتك واحصل على الدعم الذي تحتاجه',
    searchPlaceholder: 'ابحث عن المساعدة...',
    gettingStarted: 'البدء',
    membership: 'العضوية',
    billing: 'الفواتير',
    technical: 'التقنية',
    mobileApp: 'تطبيق الجوال',
    reports: 'التقارير',
    frequentlyAsked: 'الأسئلة الشائعة',
    noResults: 'لم يتم العثور على نتائج. جرب كلمات مفتاحية مختلفة.',
    stillNeedHelp: 'لا تزال بحاجة إلى مساعدة؟',
    contactTeam: 'فريق الدعم لدينا هنا لمساعدتك على مدار الساعة',
    emailSupport: 'الدعم عبر البريد الإلكتروني',
    callUs: 'اتصل بنا',
    
    faq1: {
      question: 'كيف أبدأ مع 5vix؟',
      answer: 'البدء سهل! ما عليك سوى التسجيل للحصول على نسخة تجريبية مجانية، وإكمال معالج الإعداد، ويمكنك البدء في إدارة صالة الألعاب الرياضية الخاصة بك على الفور. سيرشدك فريقنا خلال عملية الإعداد الأولية.'
    },
    faq2: {
      question: 'ما هي طرق الدفع التي تقبلونها؟',
      answer: 'نقبل جميع بطاقات الائتمان الرئيسية (فيزا، ماستركارد، أمريكان إكسبريس)، وPayPal، والتحويلات البنكية. تتم معالجة جميع المدفوعات بشكل آمن من خلال بوابة الدفع المشفرة لدينا.'
    },
    faq3: {
      question: 'كيف أضيف أعضاء جدد إلى النظام؟',
      answer: 'يمكنك إضافة أعضاء جدد من خلال قسم الأعضاء في لوحة التحكم الخاصة بك. انقر على "إضافة عضو"، املأ تفاصيلهم، اختر خطة العضوية، وقم بمعالجة الدفع. سيتلقى الأعضاء بريدًا إلكترونيًا ترحيبيًا تلقائيًا.'
    },
    faq4: {
      question: 'هل يمكن للأعضاء حجز الفصول من خلال تطبيق الجوال؟',
      answer: 'نعم! يمكن للأعضاء تنزيل تطبيق الجوال الخاص بنا، وتسجيل الدخول باستخدام بيانات الاعتماد الخاصة بهم، وحجز الفصول، وعرض الجداول، وتتبع تقدمهم، وإدارة عضويتهم مباشرة من هواتفهم.'
    },
    faq5: {
      question: 'كيف أقوم بإعداد الفواتير المتكررة؟',
      answer: 'يتم إعداد الفواتير المتكررة تلقائيًا عند إنشاء خطة عضوية. يمكنك تكوين تكرار الفواتير (شهريًا، ربع سنويًا، سنويًا) وسيقوم النظام تلقائيًا بتحصيل رسوم من الأعضاء في تاريخ التجديد الخاص بهم.'
    },
    faq6: {
      question: 'ماذا يحدث إذا فشل الدفع؟',
      answer: 'إذا فشل الدفع، سيحاول النظام تلقائيًا مرة أخرى بعد 3 أيام. سيتلقى الأعضاء إشعارات بريد إلكتروني حول فشل الدفع. يمكنك أيضًا معالجة المدفوعات يدويًا أو تحديث طرق الدفع في ملف تعريف العضو.'
    },
    faq7: {
      question: 'كيف أقوم بالتكامل مع أنظمتي الحالية؟',
      answer: 'يوفر 5vix تكامل API ويدعم تكاملات الطرف الثالث المختلفة. اتصل بفريق الدعم الفني لدينا لمناقشة احتياجات التكامل المحددة الخاصة بك وسنساعدك في إعداده.'
    },
    faq8: {
      question: 'هل بياناتي آمنة؟',
      answer: 'بالتأكيد! نستخدم التشفير على مستوى البنوك (SSL/TLS) لحماية جميع البيانات. يتم استضافة خوادمنا في مراكز بيانات آمنة مع مراقبة على مدار الساعة طوال أيام الأسبوع، ونسخ احتياطية منتظمة، والامتثال لمعايير حماية البيانات الدولية.'
    },
    faq9: {
      question: 'كيف أقوم بتنزيل تطبيق الجوال؟',
      answer: 'تطبيق 5vix للجوال متاح لكل من iOS و Android. ابحث عن "5vix" في App Store أو Google Play Store، أو قم بزيارة موقعنا الإلكتروني للحصول على روابط التنزيل المباشرة.'
    },
    faq10: {
      question: 'هل يمكنني تخصيص العلامة التجارية لتطبيق الجوال؟',
      answer: 'نعم! مع خططنا الاحترافية والمتكاملة، يمكنك تخصيص التطبيق بشعار صالة الألعاب الرياضية الخاصة بك وألوانها وعلامتها التجارية. اتصل بفريق الدعم لدينا لإعداد العلامة التجارية المخصصة لتطبيق الجوال الخاص بك.'
    },
    faq11: {
      question: 'ما هي التقارير المتاحة؟',
      answer: 'نقدم تقارير شاملة بما في ذلك تحليل الإيرادات، وإحصائيات العضوية، وتتبع الحضور، وشعبية الفصول، وأداء المدربين، والتقارير المخصصة. يمكن تصدير جميع التقارير إلى PDF أو Excel.'
    },
    faq12: {
      question: 'هل يمكنني جدولة التقارير التلقائية؟',
      answer: 'نعم! يمكنك جدولة التقارير ليتم إنشاؤها تلقائيًا وإرسالها إليك عبر البريد الإلكتروني يوميًا أو أسبوعيًا أو شهريًا. قم بإعداد التقارير التلقائية في قسم التقارير في لوحة التحكم الخاصة بك.'
    }
  },
  
  terms: {
    title: 'الشروط والأحكام',
    lastUpdated: 'آخر تحديث: يناير 2025',
    section1: {
      title: '1. قبول الشروط',
      content1: 'من خلال الوصول إلى نظام إدارة الصالات الرياضية 5vix واستخدامه، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي جزء من هذه الشروط، فلا يجوز لك استخدام خدماتنا.',
      content2: 'تنطبق هذه الشروط على جميع مستخدمي النظام، بما في ذلك أصحاب الصالات الرياضية والمسؤولين والمدربين والأعضاء.'
    },
    section2: {
      title: '2. حسابات المستخدمين والتسجيل',
      content: 'لاستخدام خدماتنا، يجب عليك:',
      item1: 'تقديم معلومات تسجيل دقيقة وكاملة',
      item2: 'الحفاظ على أمان بيانات اعتماد حسابك',
      item3: 'إخطارنا فوراً بأي وصول غير مصرح به',
      item4: 'تحمل المسؤولية عن جميع الأنشطة تحت حسابك'
    },
    section3: {
      title: '3. وصف الخدمة',
      content: 'توفر 5vix منصة شاملة لإدارة الصالات الرياضية تتضمن:',
      item1: 'إدارة الأعضاء وتتبعهم',
      item2: 'جدولة الحصص والحجز',
      item3: 'معالجة الدفع والفواتير',
      item4: 'تحليلات الأداء والتقارير',
      item5: 'الوصول إلى تطبيق الهاتف المحمول للأعضاء والموظفين'
    },
    section4: {
      title: '4. شروط الدفع',
      content1: 'يتم إصدار فواتير رسوم الاشتراك مقدماً على أساس شهري أو سنوي. جميع الرسوم غير قابلة للاسترداد إلا كما يقتضي القانون.',
      content2: 'أنت تفوضنا بتحصيل رسوم من طريقة الدفع الخاصة بك مقابل جميع الرسوم. إذا فشل الدفع، فقد نعلق أو ننهي وصولك إلى الخدمة.'
    },
    section5: {
      title: '5. مسؤوليات المستخدم',
      content: 'يوافق المستخدمون على:',
      item1: 'استخدام الخدمة فقط للأغراض القانونية',
      item2: 'عدم التدخل في الخدمة أو تعطيلها',
      item3: 'عدم محاولة الحصول على وصول غير مصرح به إلى أي جزء من النظام',
      item4: 'الامتثال لجميع القوانين واللوائح المعمول بها'
    },
    section6: {
      title: '6. الملكية الفكرية',
      content: 'جميع المحتويات والميزات والوظائف الخاصة بمنصة 5vix مملوكة لنا ومحمية بموجب قوانين حقوق النشر والعلامات التجارية وغيرها من قوانين الملكية الفكرية الدولية.'
    },
    section7: {
      title: '7. تحديد المسؤولية',
      content: 'إلى أقصى حد يسمح به القانون، لن تكون 5vix مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية ناتجة عن استخدامك أو عدم قدرتك على استخدام الخدمة.'
    },
    section8: {
      title: '8. معلومات الاتصال',
      content: 'إذا كان لديك أي أسئلة حول هذه الشروط والأحكام، يرجى الاتصال بنا:',
      email: 'البريد الإلكتروني:',
      phone: 'الهاتف:'
    },
    cta: {
      title: 'هل أنت مستعد للبدء؟',
      subtitle: 'انضم إلى آلاف الصالات الرياضية التي تستخدم 5vix لإدارة أعمالها',
      helpCenter: 'زيارة مركز المساعدة'
    }
  },

  // Privacy Policy
  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث: يناير 2024',
    introduction: 'في 5vix، نحن ملتزمون بحماية خصوصيتك وضمان أمان معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام والكشف عن وحماية معلوماتك عند استخدام نظام إدارة الصالة الرياضية والخدمات ذات الصلة.',
    section1: {
      title: '1. المعلومات التي نجمعها',
      subtitle1: 'المعلومات الشخصية',
      content1: 'نجمع المعلومات الشخصية التي تقدمها لنا مباشرة، بما في ذلك اسمك وعنوان بريدك الإلكتروني ورقم هاتفك وتاريخ ميلادك ومعلومات الدفع وتفاصيل عضوية الصالة الرياضية.',
      subtitle2: 'معلومات الاستخدام',
      content2: 'نجمع تلقائيًا معلومات حول استخدامك لخدماتنا، بما في ذلك أوقات تسجيل الدخول والميزات التي تم الوصول إليها وبيانات التمرين وسجلات الحضور ومعلومات الجهاز.',
      subtitle3: 'بيانات الصحة واللياقة البدنية',
      content3: 'بموافقتك، قد نجمع معلومات متعلقة بالصحة واللياقة البدنية مثل روتين التمارين وقياسات الجسم وأهداف اللياقة البدنية وبيانات تتبع التقدم.'
    },
    section2: {
      title: '2. كيف نستخدم معلوماتك',
      content: 'نستخدم المعلومات التي نجمعها للأغراض التالية:',
      item1: 'لتوفير وصيانة وتحسين خدمات إدارة الصالة الرياضية لدينا',
      item2: 'لمعالجة مدفوعات عضويتك وإدارة حسابك',
      item3: 'لإرسال التحديثات المهمة والإشعارات والمواد الترويجية',
      item4: 'لتخصيص تجربتك وتقديم توصيات مخصصة',
      item5: 'لتحليل أنماط الاستخدام وتحسين أداء منصتنا'
    },
    section3: {
      title: '3. مشاركة المعلومات والإفصاح عنها',
      content: 'نحن لا نبيع أو نتاجر أو نؤجر معلوماتك الشخصية لأطراف ثالثة. قد نشارك معلوماتك فقط في الظروف التالية: بموافقتك، للامتثال للالتزامات القانونية، لحماية حقوقنا وسلامتنا، أو مع مزودي الخدمة الذين يساعدوننا في تشغيل منصتنا بموجب اتفاقيات سرية صارمة.'
    },
    section4: {
      title: '4. أمان البيانات',
      content: 'نطبق تدابير أمنية متوافقة مع معايير الصناعة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو الكشف أو التعديل أو التدمير. يتضمن ذلك التشفير والخوادم الآمنة وعمليات التدقيق الأمني المنتظمة وضوابط الوصول. ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100٪، ولا يمكننا ضمان الأمان المطلق.'
    },
    section5: {
      title: '5. ملفات تعريف الارتباط وتقنيات التتبع',
      content: 'نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتحسين تجربتك على منصتنا. تساعدنا ملفات تعريف الارتباط على تذكر تفضيلاتك وتحليل حركة المرور على الموقع وتقديم محتوى مخصص. يمكنك التحكم في إعدادات ملفات تعريف الارتباط من خلال متصفحك، ولكن تعطيل ملفات تعريف الارتباط قد يحد من بعض ميزات خدماتنا.'
    },
    section6: {
      title: '6. حقوقك وخياراتك',
      content: 'لديك الحقوق التالية فيما يتعلق بمعلوماتك الشخصية:',
      item1: 'الوصول إلى ومراجعة بياناتك الشخصية المخزنة في نظامنا',
      item2: 'طلب تصحيح المعلومات غير الدقيقة أو غير الكاملة',
      item3: 'طلب حذف بياناتك الشخصية، مع مراعاة المتطلبات القانونية',
      item4: 'إلغاء الاشتراك في الاتصالات التسويقية في أي وقت'
    },
    section7: {
      title: '7. روابط الطرف الثالث',
      content: 'قد تحتوي منصتنا على روابط لمواقع أو خدمات طرف ثالث. نحن لسنا مسؤولين عن ممارسات الخصوصية لهذه المواقع الخارجية. نشجعك على مراجعة سياسات الخصوصية لأي خدمات طرف ثالث تصل إليها من خلال منصتنا.'
    },
    section8: {
      title: '8. التغييرات على سياسة الخصوصية هذه',
      content: 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر لتعكس التغييرات في ممارساتنا أو المتطلبات القانونية. سنخطرك بأي تغييرات جوهرية من خلال نشر السياسة المحدثة على موقعنا وتحديث تاريخ "آخر تحديث". يشكل استمرارك في استخدام خدماتنا بعد هذه التغييرات قبولًا للسياسة المحدثة.'
    },
    section9: {
      title: 'اتصل بنا',
      content: 'إذا كان لديك أي أسئلة أو مخاوف أو طلبات بخصوص سياسة الخصوصية هذه أو ممارسات البيانات الخاصة بنا، يرجى الاتصال بنا:'
    },
    cta: {
      title: 'هل أنت مستعد للبدء؟',
      subtitle: 'انضم إلى آلاف عشاق اللياقة البدنية الذين يستخدمون 5vix لتحقيق أهدافهم',
      button: 'ابدأ التجربة المجانية'
    }
  },

  // Blog Page
  'blog.title': 'مدونة اللياقة والصحة',
  'blog.subtitle': 'نصائح الخبراء والأدلة والرؤى لمساعدتك على تحقيق أهداف اللياقة البدنية',
  'blog.allArticles': 'جميع المقالات',
  'blog.fitness': 'اللياقة البدنية',
  'blog.nutrition': 'التغذية',
  'blog.wellness': 'الصحة',
  'blog.training': 'التدريب',
  'blog.newsletterTitle': 'اشترك في نشرتنا الإخبارية',
  'blog.newsletterDesc': 'احصل على أحدث نصائح اللياقة البدنية والصحة في بريدك الإلكتروني',
  
  'blog.article1.title': '10 تمارين أساسية لبناء القوة',
  'blog.article1.excerpt': 'اكتشف التمارين الأساسية التي تشكل أساس أي برنامج تدريب قوة فعال. تعلم الشكل والتقنية الصحيحة لتحقيق أقصى النتائج.',
  
  'blog.article2.title': 'دليل شامل لتخطيط الوجبات للرياضيين',
  'blog.article2.excerpt': 'أتقن فن تخطيط التغذية مع دليلنا الشامل. تعلم كيفية تزويد جسمك بالطاقة للأداء الأمثل والتعافي.',
  
  'blog.article3.title': 'أهمية الراحة والتعافي',
  'blog.article3.excerpt': 'فهم سبب أهمية أيام الراحة للتقدم. تعلم كيفية تحسين تعافيك لأداء أفضل والوقاية من الإصابات.',
  
  'blog.article4.title': 'تدريب HIIT: الفوائد وأفضل الممارسات',
  'blog.article4.excerpt': 'استكشف العلم وراء التدريب المتقطع عالي الكثافة وكيفية دمجه بفعالية في روتين اللياقة البدنية الخاص بك.',
  
  'blog.article5.title': 'أساسيات التمرين المنزلي: لا حاجة للصالة الرياضية',
  'blog.article5.excerpt': 'احصل على اللياقة من راحة منزلك مع هذه التمارين الفعالة والمعدات البسيطة. مثالي للجداول المزدحمة.',
  
  'blog.article6.title': 'تناول البروتين: كم تحتاج حقاً؟',
  'blog.article6.excerpt': 'دحض الخرافات حول استهلاك البروتين وتقديم توصيات قائمة على الأدلة لأهداف اللياقة المختلفة.',
  
  'blog.article7.title': 'تحسين النوم لأداء أفضل',
  'blog.article7.excerpt': 'تعرف على كيفية تأثير جودة النوم على نتائج لياقتك واكتشف استراتيجيات لتحسين جودة نومك.',
  
  'blog.article8.title': 'تدريب القوة للمبتدئين: دليل كامل',
  'blog.article8.excerpt': 'كل ما تحتاج لمعرفته لبدء رحلة تدريب القوة بأمان وفعالية. من الأساسيات إلى النصائح المتقدمة.',
  
  'blog.article9.title': 'المرونة والحركة: الحلقة المفقودة',
  'blog.article9.excerpt': 'لماذا يعد تدريب المرونة ضرورياً للياقة البدنية الشاملة وكيفية دمجه في روتينك للحصول على نتائج أفضل.',

  stats: {
    revenue: 'الإيرادات',
    fromPreviousMonth: 'من الشهر السابق',
    netProfit: 'صافي الربح',
    income: 'الدخل',
    expenses: 'المصروفات',
    members: 'الأعضاء',
    organicSources: 'المصادر العضوية',
    socialMedia: 'وسائل التواصل الاجتماعي',
    friends: 'الأصدقاء',
    directVisit: 'زيارة مباشرة',
    calls: 'المكالمات',
    billingStatus: 'حالة الفاتورة',
    draft: 'مسودة',
    sent: 'مرسلة',
    paid: 'مدفوعة',
    partiallyPaid: 'مدفوعة جزئياً',
    overdue: 'متأخرة'
  },

};
